import React, { useState, useEffect, useContext } from 'react';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Button } from '@material-ui/core';
import { AppContext } from 'contexts';
import { validateAdminToken } from 'utils';

const useStyles = makeStyles({
  reviewer: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    top: 10,
    right: 20,
  },
  button: {
    color: '#000',
    textTransform: 'capitalize',
    border: '1px solid #fff',
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
    marginLeft: 10,
    padding: '3px 16px',

    '&:first-child': {
      marginLeft: 0,
    },

    '&.accepted': {
      color: 'white',
      backgroundColor: 'green',
    },

    '&.rejected': {
      color: 'white',
      backgroundColor: 'red',
    },
  },
});

function Reviewer() {
  const classes = useStyles();

  const appContext = useContext(AppContext);
  const { adminToken, currentRoom, currentMarker, setMarkerState } = appContext;

  const [state, setState] = useState(0);
  const [hasAdminToken, setHasAdminToken] = useState(false);

  useEffect(() => {
    if (!adminToken) return;

    const checkToken = () => {
      validateAdminToken(adminToken).then((result: boolean) => {
        setHasAdminToken(result);
      });
    };

    checkToken();
  }, [adminToken]);

  useEffect(() => {
    if (!currentRoom || !currentRoom.markers || !currentRoom.markers[currentMarker]) {
      return;
    }
    setState(currentRoom.markers[currentMarker].state);
  }, [currentRoom]);

  if (!hasAdminToken) return null;

  const onAccept = () => {
    setMarkerState(true);
  };

  const onReject = () => {
    setMarkerState(false);
  };

  return (
    <Box className={classes.reviewer}>
      <Button
        className={classNames(classes.button, { accepted: state === 1 })}
        onClick={onAccept}
        onTouchEnd={onAccept}
      >
        Approve
      </Button>
      <Button
        className={classNames(classes.button, { rejected: state === 2 })}
        onClick={onReject}
        onTouchEnd={onReject}
      >
        Rejected
      </Button>
    </Box>
  );
}

export default Reviewer;
